import React, { type FC } from 'react'
import { Space, Select, Button, Flex } from 'antd'
import { CheckboxUncheckedRegular, CheckboxCheckedFilled } from '@fluentui/react-icons'
import { ISelectOption } from '../../constants/types/common'

interface IDropdownFilterProps {
  value: string[] | null
  options: ISelectOption[]
  selectAllAction: () => void
  clearAllAction: () => void
  onChange: (e) => void
  placeholder: string
  disabled?: boolean
}

export const DropdownFilter: FC<IDropdownFilterProps> = ({
  value,
  options,
  selectAllAction,
  clearAllAction,
  onChange,
  placeholder,
  disabled = false
}) => {
  return (
    <Space.Compact className='input-search'>
      <Select
        style={{ minWidth: '220px' }}
        value={value}
        mode='tags'
        disabled={disabled}
        onChange={onChange}
        aria-label='filter-select'
        options={options}
        maxTagCount={0}
        showSearch={false}
        notFoundContent='No items found'
        optionRender={(option) => {
          const isSelected = Array.isArray(value) && value.includes(option.value as string)
          return (
            <Flex align='center' gap={8} aria-label='filter-options'>
              {
                isSelected
                  ? <CheckboxCheckedFilled fontSize='x-large' />
                  : <CheckboxUncheckedRegular fontSize='x-large' />
              }
              {option.label}
            </Flex>
          )
        }}
        popupRender={(menu) => (
          <div className='resource-type-filter'>
            {menu}
            <Button data-testid='select-all-resources-btn' disabled={options.length === value?.length} type='text' onClick={selectAllAction}>Select all</Button>
            {Boolean(value?.length) && <Button type='text' onClick={clearAllAction}>Clear all</Button>}
          </div>
        )}
        placeholder={placeholder}
        maxTagPlaceholder={(omittedValues) => (
          <span>{omittedValues.length} {placeholder}</span>
        )}
      />
    </Space.Compact>
  )
}
